import React, { useCallback, useMemo } from "react";
import { Result, Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import moment from "moment-timezone";
import { CONFIG } from "../config";

const OrderSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state = {} } = location;
  const { uploadOrdersRes = null } = state || {};
  const { clientId, preProd } = queryString.parse(location.search);

  const redirectDashboard = () => {
    const date = moment().format("YYYY-MM-DD");
    const locusUrl = `https://${!preProd ? clientId : preProd}.${CONFIG.stackDomain}/#/client/${clientId}/orders?startDate=${date}&endDate=${date}`;
    const newWindow = window.open(locusUrl, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const redirectCreateOrder = useCallback(() => {
    navigate(`/home/create-order${location.search}`, {
      state: { from: location },
    });
  }, [navigate, location]);

  const { totalCount } = useMemo(() => {
    const totalCount = uploadOrdersRes || 0;
    return { totalCount };
  }, [uploadOrdersRes]);

  return (
    <React.Fragment>
      <Result
        status="success"
        title="Orders Created"
        subTitle={`Order Created: ${totalCount}`}
        extra={[
          <Button type="primary" key="console-btn" onClick={redirectDashboard}>
            Go Dashboard
          </Button>,
          <Button key="create-btn" onClick={redirectCreateOrder}>
            Create Again
          </Button>,
        ]}
      />
    </React.Fragment>
  );
};

export default OrderSuccess;
